import { useMutation } from "@apollo/client";
import { LOGOUT } from "./api";

export function useLogout() {
  const [logout] = useMutation(LOGOUT);

  return async () => {
    await logout();
    window.location.reload();
  };
}
